"use client";
import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import logo from './Assets/rentastic.png';


import Header from '../Header';
import Footer from '../Footer';

const Terms = () => {
   useEffect(() => {
        window.scrollTo(0, 0);  // ⬅️ Scroll to top when this page mounts
      }, []);
     

  return (
    <div>
     <div className="w-full">
        <Header />
      </div>
    <main className="flex gap-7 p-10 w-full min-h-screen bg-neutral-50 max-xl:flex-col max-xl:gap-5 max-md:p-5 max-sm:p-4">
      {/* <div className="flex-shrink-0 w-[285px] max-xl:w-full">
        <FilterSidebar />
      </div> */}

      <section className="flex flex-col flex-1 gap-5 min-w-0">
        <div className="bg-gray-50 min-h-screen pl-6">
      {/* Privacy Policy Heading */}
    <h2
  className="
    text-lg sm:text-xl md:text-xl lg:text-xl
    font-semibold
    text-gray-800
    mb-4 sm:mb-6
    text-center sm:text-left
    pl-0 sm:pl-8 md:pl-10 lg:pl-[36px]
    ml-0 sm:ml-8 md:ml-14
  "
>
        Terms & Conditions
      </h2>

      {/* Card */}
      
        <div className="bg-white rounded-2xl shadow-lg p-8 max-w-5xl mx-auto">
        {/* Logo + Title Centered (side by side) */}
        <div className="flex items-center justify-center gap-3 mb-8">
          <img
            src="https://cdn.acsdev.in/Rentastic/rentastic.png" // replace with your actual logo path
            alt="Rentastic Toys"
            className="w-16 h-16"
          />
          <h2 className="text-2xl font-bold">Rentastic Toys</h2>
        </div>

        {/* Content */}
        <div className="space-y-5 text-gray-700 leading-relaxed">
          <h1>These Terms & Conditions (“Terms”) govern your access to and use of toy-rental subscription services provided by Rentastic Toys, including our website, mobile application, product delivery, 
            and account services (collectively, the “Service”). By subscribing to or using the Service, you agree to comply with and be bound by these Terms.</h1>
            <br/>
            Rentastic Toys provides temporary subscription access to toys for household use within the United States.
            These Terms apply to all subscribers (“Customers”) and govern participation in the Service.
          <p>
            <strong>1. Subscription Services and Automatic Billing</strong>
            Subscription fees are billed in U.S. Dollars (USD) on a recurring monthly basis unless canceled before the next billing date.
             Customers must maintain an active payment method. Once a billing cycle begins, all charges are considered final and non-refundable.
              Rentastic Toys may adjust pricing or plan features with advance notice.
            <br/>
            Suspension of access may occur if payment fails or if account activity violates these Terms.
          </p>

          <p>
            <strong>2.Delivery and Returns</strong> 
              Rentastic Toys delivers toys throughout the United States. Delivery times may vary based on location and availability. 
              Customers must provide accurate delivery information and ensure safe access for receipt and pickup of toys.
              <br/>
              All toys remain the exclusive property of Rentastic Toys and must be returned before any additional toys will be shipped.
               Toys must be returned within sixty (60) days after each monthly renewal date. Toys not returned by this deadline will be
               considered permanently unreturned and charged as described below.

          </p>

          <p>
            <strong>3.Product Use and Customer Responsibilities</strong> 
            Customers are responsible for the care and proper handling of toys during the subscription period. 
            Customers must ensure that toys are used under the direct supervision of a responsible adult 
            and that toys are appropriate for the child’s age and developmental level, including reviewing any safety warnings and hazard notices.
            <br/>
            Products may not be altered, resold, gifted, or used for any commercial purpose. Normal wear from ordinary play is expected.
          </p>

          <p>
            <strong>4. Replacement Charges for Lost or Damaged Toys</strong> 
            If a toy is lost, irreparably damaged, or unsafe for continued rental, 
            Rentastic Toys may charge the Customer a replacement cost equal to the current
            retail value from Amazon, Target, Walmart, or a comparable retailer — whichever is higher.
            The determination of product condition and replacement value is at the 
            sole discretion of Rentastic Toys. Any replacement or outstanding charges may be 
            automatically charged to the payment method on file.
          </p>

          <p>
            <strong>5. Care of Toys</strong> 
            Rentastic Toys makes reasonable efforts to ensure toys are clean, sanitized, and in working condition before delivery. However, toys inherently present safety risks.
            <br/>
            Upon delivery, Customers assume full responsibility for supervision and monitoring of toy usage. Rentastic Toys does not guarantee that any product is free from hazards or provides any specific developmental or educational benefit.
            <br/>
            To the fullest extent permitted by law, Rentastic Toys shall not be liable for:
            <ul class="list-disc list-inside pl-3'">
              <li>Personal injury, choking incidents, ingestion or insertion of toy parts</li>
              <li>Allergic reactions or health-related responses</li>
              <li>Injury or harm caused by misuse, inadequate supervision, or age-inappropriate use</li>
              <li>Any indirect, incidental, consequential, punitive, or special damages</li>
            </ul>
            Customers agree to indemnify and hold Rentastic Toys harmless from claims, damages, and legal costs arising from use or misuse of toys.
            <br/>
            No warranties, express or implied, are provided with respect to rented products.
          </p>

          <p>
            <strong>6.Account Suspension and Termination</strong>
            Rentastic Toys reserves the right to suspend or terminate a subscription due to unpaid charges, overdue returns, misuse of toys, fraud, or violation of these Terms. 
            Customers remain responsible for all amounts incurred prior to suspension or termination. Cancellation takes effect at the end of the current billing period.
          </p>

          <p>
            <strong>7. Intellectual Property</strong> <br/>
            All trademarks, content, and proprietary materials made available through the Service remain the property of Rentastic Toys and may not be copied, distributed, or reproduced without written consent.

          </p>

          <p>
            <strong>8. Governing Law</strong><br/>
            These Terms are governed by and construed in accordance with the laws of the United States and the state in which Rentastic Toys primarily conducts business.
            Customers agree to resolve all disputes exclusively in U.S. courts.
          </p>
           <p>
            <strong>9. Amendments</strong> 
            Rentastic Toys may update these Terms at any time. Continued use of the Service constitutes acceptance of any revised Terms.
          </p>
           <p>
            <strong>10. Contact</strong> <br/>
            For questions related to these Terms:<br/>
            Email : <strong>rentastictoys@gmail.com </strong><br/>
          </p>
          <p>
            By subscribing to Rentastic Toys, you acknowledge and accept all Terms & Conditions described above.
          </p>
        </div>
      </div>
    </div>

       
      </section>
    </main>
    <div className="w-full">
        <Footer />
      </div>
    </div>
  );
};

export default Terms;
